import React, {useCallback} from 'react';
import {Stack} from '@mui/material';
import {OrelyFrameV2} from '../OrelyFrame';
import {ChallengeContext} from '../../../../../redux/@types/AuthentTypes.ts';
import {useGetSignatureChallengeQuery} from '../../../../../redux/api/customerAuthentApiRtk.ts';
import {isValidBase64} from '../../../../../utils/base64.ts';
import {BglLogger} from '@bgl/lib-ts-integration';

const OrelyValidation = ({children, challengeContext, callback, jsonStructure = false}: React.PropsWithChildren<{
  challengeContext: ChallengeContext,
  callback: (challengeId: string, samlResponse: string) => void,
  jsonStructure?: boolean
}>) => {
  const {data} = useGetSignatureChallengeQuery({
    challengeContext
  }, {skip: !challengeContext});

  const isValidOrigin = (origin: string | undefined, isDev: boolean): boolean => {
    if (isDev) {
      return true;
    }
    const allowed = ['lu.fortis.bank', 'bgl.lu'];
    return !!origin && allowed.some(p => origin.includes(p));
  };

  const isValidPayload = (payload: any, challengeId?: string): boolean => {
    return !!payload && !payload.source && !!challengeId;
  };

  const _receiveMessage = useCallback(async (event: MessageEvent) => {
    const logger = BglLogger?.getInstance?.() ?? console;
    const isDev = import.meta.env?.DEV ?? false;

    if (!isValidOrigin(event.origin, isDev)) {
      return;
    }
    if (!isValidPayload(event.data, data?.challengeId)) {
      return;
    }

    const payload = typeof event.data === 'string' ? event.data : String(event.data);

    if (isValidBase64(payload)) {
      const samlResponse = payload;
      const answer = JSON.stringify({
        tokens: [{ securityToken: samlResponse }],
      });
      callback(data!.challengeId, jsonStructure ? answer : samlResponse);
    } else {
      logger.warn('event data format received not expected : ', event.data);
    }
  }, [callback, data, jsonStructure]);

  return (
    <Stack width={'100%'}>
      {children &&
          <>{children}</>
      }
      {data?.identityProviderURL && data?.samlRequest &&

        <OrelyFrameV2 receiveMessage={_receiveMessage} styling={{width: '100%', height: '500px', border: '0px'}}>
          <form
          id={'samlForm'}
          name={'samlForm'}
          action={data.identityProviderURL}
          method={'POST'}>
              <input type={'hidden'} name="SAMLRequest" value={data.samlRequest}/>
          </form>
        </OrelyFrameV2>

      }
    </Stack>
  );
};

export default OrelyValidation;
